import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
/// <reference types="@xo-union/consent-management/globals" />

import React from "react";
import noop from "lodash/noop";
// This is temporary until fragment version is adapted
const getFallbackButtonProps = () => {
  const ot = _globalThis.OneTrust;
  const data = ot.GetDomainData();
  const cm = data.ConsentModel;
  return {
    text: data.CookieSettingButtonText,
    isVisible: cm.Name !== 'notice only'
  };
};
const defaultRenderFunction = buttonProps => /*#__PURE__*/React.createElement("button", _extends({
  type: "button"
}, buttonProps));
const CookieSettingsButton = _ref => {
  let {
    children = defaultRenderFunction,
    ...rest
  } = _ref;
  const [visible, setVisible] = React.useState(false);
  const [text, setText] = React.useState('Your privacy choices');
  React.useEffect(() => {
    const uc = _globalThis.UnionConsentManagement;
    if (!uc) return noop;
    if (!uc.consentPlatformEnabled) {
      setVisible(false);
      return noop;
    }

    // wait for provider to load so we can get the final text and avoid flash of content
    const onProviderLoad = () => {
      const props = uc.getCookieSettingsButtonProps ? uc.getCookieSettingsButtonProps() : getFallbackButtonProps();
      setVisible(props.isVisible);
      setText(props.text);
    };
    uc.addEventListener('provider-load', onProviderLoad);
    return () => {
      uc.removeEventListener('provider-load', onProviderLoad);
    };
  }, []);
  const buttonProps = {
    ...rest,
    disabled: !visible,
    onClick: () => _globalThis.UnionConsentManagement.togglePreferencesModal(),
    children: text
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(buttonProps, {
    text,
    visible
  }));
};
export default CookieSettingsButton;